import {getUUID, log, logGroupEnd, logGroupStart, merge, pipe, tap} from '@logistics-frontend/utils'
import {useParams} from 'react-router-dom'

import {appConfig} from 'src/shared/config'
import {HomePageParams} from 'src/shared/routes/types'
import {DeliveryType, DestinationPointDeliveryMethod, Order as FormValues, VerticalTariff} from 'src/shared/types'
import {toDestinationPoints} from 'src/widgets/DestinationPoints/utils/to-destination-point'
import {BUSINESS_VERTICALS} from 'src/widgets/VerticalsDeprecated/consts'

import {restoreFormValues} from '../../consts'
import {toSourcePoint} from './utils/to-source-point'
import {withCorrectPointContact} from './utils/with-correct-point-contact'

// fixme нужно убрать прямой кастинг, это выстрел в колено
function FIXME_toDefaultValues(): FormValues {
  const sddClaimInfo = undefined // в ЛК приходит с бекенда
  const isCard = true // clientType === 'card'
  const sourcePoint = toSourcePoint(sddClaimInfo, isCard)
  sourcePoint.contact = withCorrectPointContact(sourcePoint, appConfig.launch)
  sourcePoint.address.coordinates = appConfig.location

  return {
    sourcePoint,
    deliveryType: DeliveryType.Express,
    isBusiness: false,
    destinationPoints: toDestinationPoints(sddClaimInfo, isCard, DestinationPointDeliveryMethod.PickUpPoint),
    offerId: getUUID(),
    ndd: {
      deliveryDate: undefined,
    },
    offerFlow: {
      vertical: undefined,
      id: undefined,
      version: undefined,
    },
    __settings: {
      __sddClaim: sddClaimInfo,
    },
  } as FormValues
}

export function useDefaultFormValues() {
  const {tariff} = useParams<HomePageParams>()
  const isBusiness = BUSINESS_VERTICALS.includes(tariff)
  const vertical: VerticalTariff | undefined = tariff ? {name: tariff} : undefined

  const valuesFromUrl: Partial<FormValues> = {
    isBusiness,
    offerFlow: {vertical},
  }

  return pipe(
    FIXME_toDefaultValues(),
    tap(logGroupStart('Начальный стейт формы', true)),
    tap(log('Дефолтный стейт')),
    tap(() => log('Стейт в урле')(valuesFromUrl)),
    (values: FormValues) => merge(values, valuesFromUrl),
    tap(log('Стейт формы после мерджа с урлом')),
    restoreFormValues,
    tap(log('Итоговый стейт')),
    tap(logGroupEnd()),
  )
}
